<template>
  <aside class="bg-white rounded-xl  border-b-4 border-h-primary-700 w-full">
    <h5 class="px-5">{{ "Lista de capítulos" }}</h5>

    <SidebarChapters class="overflow-auto h-[80vh] scroll-style p-5">
      <SidebarTrails>
        <SidebarMaterials />
      </SidebarTrails>
    </SidebarChapters>
  </aside>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";

const SidebarChapters = defineAsyncComponent(() => import("./chapters.vue"));
const SidebarTrails = defineAsyncComponent(() => import("./trails.vue"));
const SidebarMaterials = defineAsyncComponent(() => import("./materials.vue"));

export default defineComponent({
  name: "SidebarMenu",
  components: {
    SidebarChapters,
    SidebarTrails,
    SidebarMaterials,
  },
});
</script>
